import Article from '@mui/icons-material/Article';
import Badge from '@mui/material/Badge';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import type { MouseEvent } from 'react';

interface Props {
    count: number;
    tooltipTitle: string;
    onClick?: (e: MouseEvent<HTMLDivElement>) => void;
}

/**
 * Same visual language as CustomMarker (Article) but with a count badge for multiple items at one coordinate.
 */
const MapStackedItemsMarker = ({ count, tooltipTitle, onClick }: Props) => {
    return (
        <Box
            onClick={(e) => {
                e.stopPropagation();
                onClick?.(e);
            }}
            sx={{ display: 'inline-flex', cursor: 'pointer' }}
        >
            <Tooltip title={tooltipTitle}>
                <Badge
                    badgeContent={count}
                    color="primary"
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    sx={{
                        '& .MuiBadge-badge': {
                            fontWeight: 700,
                            minWidth: 20,
                            height: 20,
                        },
                    }}
                >
                    <Article
                        fontSize="large"
                        sx={{
                            color: 'error.main',
                            display: 'block',
                            ':hover': {
                                transform: 'scale3d(1.2, 1.2, 1)',
                                transition: 'transform 0.15s ease-in-out',
                            },
                        }}
                    />
                </Badge>
            </Tooltip>
        </Box>
    );
};

export default MapStackedItemsMarker;
